import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useMemo, useRef } from "react";
import { Empty, List, Skeleton } from "antd";
import { useI18n, useListService } from "../../../contexts";
import { ListServiceRow } from "../..";
import { useDndSortable } from "../../../hooks";
const ListService = ()=>{
    const { __, _i } = useI18n();
    const { isEssential, isOnlyRealCookieBannerServiceCreated, busy, rows, onSort, onCreate, servicesCount, groupName } = useListService();
    const sortableBodyRef = useRef();
    const { SortableContext, SortableRow, DragHandle } = useDndSortable();
    const dataSourceSkeleton = useMemo(()=>{
        const d = [];
        for(let key = 0; key < servicesCount; key++){
            d.push({
                key
            });
        }
        return d;
    }, [
        servicesCount
    ]);
    const addText = __("Add service");
    // UX: Do not show the list of cookies until the user has created the first cookie
    const showList = isEssential ? isOnlyRealCookieBannerServiceCreated ? servicesCount > 1 : servicesCount > 0 : servicesCount > 0;
    const items = rows.map((param)=>{
        let { attributes: { id } } = param;
        return `${id}`;
    });
    return showList ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "wp-clearfix",
                children: /*#__PURE__*/ _jsx("a", {
                    onClick: onCreate,
                    className: "button button-primary right",
                    style: {
                        marginBottom: 10
                    },
                    children: addText
                })
            }),
            busy ? /*#__PURE__*/ _jsx(List, {
                dataSource: dataSourceSkeleton,
                renderItem: ()=>/*#__PURE__*/ _jsx(List.Item, {
                        children: /*#__PURE__*/ _jsx(Skeleton, {
                            loading: true,
                            active: true,
                            paragraph: {
                                rows: 1
                            }
                        })
                    })
            }) : /*#__PURE__*/ _jsx(SortableContext, {
                items: items,
                onDragEnd: (param)=>{
                    let { active, over } = param;
                    const from = rows.findIndex((field)=>field.attributes.id === +active.id);
                    const to = rows.findIndex((field)=>field.attributes.id === +(over == null ? void 0 : over.id));
                    onSort(items.map(Number), from, to);
                },
                elementType: "div",
                children: /*#__PURE__*/ _jsx(List, {
                    children: /*#__PURE__*/ _jsx("div", {
                        ref: sortableBodyRef,
                        children: rows.map((row, index)=>/*#__PURE__*/ _jsx(SortableRow, {
                                "data-row-key": `${row.attributes.id}`,
                                children: /*#__PURE__*/ _createElement(ListServiceRow, {
                                    ...row,
                                    key: row.attributes.id.toString(),
                                    dragHandle: /*#__PURE__*/ _jsx(DragHandle, {})
                                })
                            }, row.attributes.id))
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ _jsx(Empty, {
        description: _i(__("You have not yet created a service in {{strong}}%s{{/strong}}.", groupName), {
            strong: /*#__PURE__*/ _jsx("strong", {})
        }),
        children: /*#__PURE__*/ _jsx("a", {
            className: "button button-primary",
            onClick: onCreate,
            children: addText
        })
    });
};
export { ListService };
